export default "__VITE_ASSET__PQIptOFc__"